import { apiClient } from '~/api/client';

type IndexParams = {
  agent_profile_id: number;
};

export const options = async ({ agent_profile_id }: IndexParams) =>
  apiClient.get(`/verification_options?agent_profile_id=${agent_profile_id}`);
